/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { sessionsAPI } from 'src/api/modules/sessions';
import notice from 'src/common/components/Notice';

export const useSavePublishSession = (
	btnPublishSession,
	id,
	inputUser,
	mailSession,
	mailAnnouncement,
	setInputUser,
	users
) => {
	const [dataSaved, setDataSaved] = useState(null);
	const [loading, setLoading] = useState(true);

	const getCurrentSession = () => {
		sessionsAPI
			.getSessionExisting({
				sesionId: id,
				consultarPublicacion: true,
			})
			.then((response) => {
				if (!response) return;
				const input1 = users
					.filter((person) =>
						response.usuariosConvocatoria
							.map((item) => +item)
							.includes(person.id)
					)
					.map((person) => ({ value: person.id, text: person.name }));

				const input2 = users
					.filter((person) =>
						response.usuariosPublicarSesion
							.map((item) => +item)
							.includes(person.id)
					)
					.map((person) => ({ value: person.id, text: person.name }));

				setInputUser({
					users1: input1,
					users2: input2,
				});

				setDataSaved(response);
			})
			.catch(() => {
				//notice('Ocurrio un error', 'error');
			})
			.finally(() => setLoading(false));
	};

	useEffect(() => {
		if (btnPublishSession) getCurrentSession();
	}, [btnPublishSession]);

	const onSaveData = () => {
		sessionsAPI
			.getSessionExisting({
				sesionId: id,
				usuariosConvocatoria: inputUser.users1.map((user) => user.value),
				mensajeConvocatoria: mailAnnouncement,
				usuariosPublicarSesion: inputUser.users2.map((user) => user.value),
				mensajePublicarSesion: mailSession,
				consultarPublicacion: false,
			})
			.then(() => {
				notice('Se guardo correctamente la información', 'info');
			})
			.catch((e) => {
				notice('Ocurrio un error', 'error');
			});
	};

	return { dataSaved, onSaveData, setDataSaved, loading };
};
